import React from 'react';
import { Mail, MapPin, ExternalLink } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-slate-900 pt-16 pb-8 border-t border-slate-800" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-112">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-113">
            <div className="mb-6" data-id="element-114">
              <Logo className="h-16 w-[260px]" variant="inverted" data-id="element-115" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md mb-6" data-id="element-116">
              BetterCode is a software modernization and engineering
              transformation brand owned and operated by Xeynergy. We help
              organizations execute migrations, conversions, and continuous
              improvements.
            </p>
            <a href="https://xeynergy.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm font-medium text-brand-green hover:text-brand-greenHover transition-colors" data-id="element-117">
              Visit Xeynergy <ExternalLink className="ml-1 h-3 w-3" data-id="element-118" />
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-119">
            <h4 className="text-white font-semibold mb-6 font-heading" data-id="element-120">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-121">
              <li data-id="element-122">
                <a href="#deliver" className="hover:text-brand-green transition-colors" data-id="element-123">
                  Why BetterCode
                </a>
              </li>
              <li data-id="element-124">
                <a href="#process" className="hover:text-brand-green transition-colors" data-id="element-125">
                  Our Process
                </a>
              </li>
              <li data-id="element-126">
                <a href="#who-for" className="hover:text-brand-green transition-colors" data-id="element-127">
                  Who It's For
                </a>
              </li>
              <li data-id="element-128">
                <a href="#cases" className="hover:text-brand-green transition-colors" data-id="element-129">
                  Case Studies
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-130">
            <h4 className="text-white font-semibold mb-6 font-heading" data-id="element-131">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-slate-400" data-id="element-132">
              <li className="flex items-start" data-id="element-133">
                <MapPin className="h-5 w-5 text-slate-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-134" />
                <span data-id="element-135">
                  No 546/7/4 Galle Rd,
                  <br data-id="element-136" />
                  Colombo 00300,
                  <br data-id="element-137" />
                  Sri Lanka
                </span>
              </li>
              <li className="flex items-center" data-id="element-138">
                <Mail className="h-5 w-5 text-slate-500 mr-3 flex-shrink-0" data-id="element-139" />
                <a href="mailto:business@xeynergy.com" className="hover:text-brand-green transition-colors" data-id="element-140">
                  business@xeynergy.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-141">
          <p className="text-slate-500 text-sm text-center md:text-left" data-id="element-142">
            © {new Date().getFullYear()} BetterCode AI. A Xeynergy brand. All
            rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-slate-500" data-id="element-143">
            <a href="#" className="hover:text-white transition-colors" data-id="element-144">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-145">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}